<div class="d-flex align-items-center gap-3">
  <button type="button" class="no-style-button w-100" (click)="toggleAccordion()">
    <div class="remittance-id">
      <div *ngIf="!hideAccordion" class="chevron-container">
        <img
          class="chevron"
          [src]="'assets/icons/grey/Chevron Up.svg'"
          [class.expanded]="accordionExpanded$ | async"
          [class.collapsed]="!(accordionExpanded$ | async)"
          alt="" />
      </div>
      <div i18n *ngIf="!isLoading; else loadingId">R-{{ remittance?.id | leadingZero : 8 }}</div>
    </div>
  </button>
  <div class="d-flex remittance-header-status">
    <div class="d-flex gap-2 align-items-center">
      <div class="remittance-label" i18n>Status:</div>
      <app-status-pill *ngIf="!isLoading; else loadingPill" [statusPill]="remittance?.statusPill" />
    </div>
    <div class="d-flex gap-2 align-items-center">
      <div class="remittance-label" i18n>Payment:</div>
      <app-status-pill *ngIf="!isLoading; else loadingPill" [statusPill]="remittance?.paymentStatusPill" />
    </div>
    <div *ngIf="showActionButton">
      <button class="primary-paddingless-text-button" (click)="viewRemittance()">{{ buttonLabel$ | async }}</button>
    </div>
  </div>
</div>

<ng-template #loadingPill>
  <lib-loading-shimmer [borderRadius]="'1rem'" [height]="'1.5rem'" [width]="'3rem'" />
</ng-template>

<ng-template #loadingId>
  <lib-loading-shimmer [height]="'1rem'" [width]="'5rem'" />
</ng-template>
